/**
 * Persisted work info (job title + domain) detected during onboarding.
 *
 * Work info is detected server-side from the conversation transcript and written
 * to Realtime DB memory, but that write may not have propagated by the time the
 * client reads it back (and for a brand-new user the auth-time cache is empty).
 * Caching it in localStorage gives objective, recap, and planner generation a
 * reliable, immediately-available source — and carries it across a lite → signup
 * conversion within the same browser.
 */

const WORK_TITLE_KEY = 'capturedWorkTitle';
const WORK_DOMAIN_KEY = 'capturedWorkDomain';

/**
 * @returns {{work_title: string, work_domain: string}} Stored work info (empty strings if unset).
 */
export function getStoredWorkInfo() {
  return {
    work_title: localStorage.getItem(WORK_TITLE_KEY) || '',
    work_domain: localStorage.getItem(WORK_DOMAIN_KEY) || '',
  };
}

/**
 * Persist work info to localStorage. Only writes non-empty values, so a later
 * conversation that surfaces less info never clobbers a previously-captured value.
 *
 * @param {{work_title?: string, work_domain?: string}} info
 */
export function storeWorkInfo({ work_title, work_domain } = {}) {
  if (work_title) localStorage.setItem(WORK_TITLE_KEY, work_title);
  if (work_domain) localStorage.setItem(WORK_DOMAIN_KEY, work_domain);
}
